var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewResultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#FF6B00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 12.0625H21.3359C22.3379 12.0625 23.2871 12.4844 24.0254 13.2227L26.2402 15.4375H34.625C36.4707 15.4375 38 16.9668 38 18.8125V32.3125C38 34.2109 36.4707 35.6875 34.625 35.6875H14.375C12.4766 35.6875 11 34.2109 11 32.3125V15.4375C11 13.5918 12.4766 12.0625 14.375 12.0625ZM13.5312 15.4375V32.3125C13.5312 32.7871 13.9004 33.1562 14.375 33.1562H34.625C35.0469 33.1562 35.4688 32.7871 35.4688 32.3125V18.8125C35.4688 18.3906 35.0469 17.9688 34.625 17.9688H26.082C25.5547 17.9688 24.9746 17.7578 24.6055 17.3887L22.2324 14.9629C21.9688 14.752 21.6523 14.5938 21.3359 14.5938H14.375C13.9004 14.5938 13.5312 15.0156 13.5312 15.4375ZM25.7656 30.2031H25.7129C25.7129 30.9414 25.1855 31.4688 24.4473 31.4688C23.7617 31.4688 23.1816 30.9414 23.1816 30.2031V24.8242L21.5469 26.459C21.0723 26.9863 20.2812 26.9863 19.8066 26.459C19.2793 25.9844 19.2793 25.1934 19.8066 24.666L23.6035 20.8691C24.0781 20.3945 24.8691 20.3945 25.3438 20.8691L29.1406 24.666C29.668 25.1934 29.668 25.9844 29.1406 26.459C28.666 26.9863 27.875 26.9863 27.4004 26.459L25.7656 24.8242V30.2031Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewResultIcon);
export default __webpack_public_path__ + "static/media/viewResultIcon.cc6a8b7754d3d8e049a1fd7cdb66a744.svg";
export { ForwardRef as ReactComponent };